import React from 'react';
import ReactDOM from 'react-dom';
import './index.css';
import App from './App';
import reportWebVitals from './reportWebVitals';
import { ChakraProvider, extendTheme } from '@chakra-ui/react';
import { ReactKeycloakProvider } from '@react-keycloak/web';
import keycloak from './auth/keycloak';

// TODO: Fix up the colors for light and dark mode
// https://chakra-ui.com/docs/styled-system/color-mode#usecolormode
// and follow the color mode setup guide here to properly use color mode
// https://chakra-ui.com/docs/styled-system/color-mode#setup

const themeConfig = {
    initialColorMode: 'light',
    useSystemColorMode: false,
};

const theme = extendTheme({ themeConfig });

ReactDOM.render(
    <React.StrictMode>
        <ChakraProvider theme={theme}>
            <ReactKeycloakProvider authClient={keycloak}>
                <App />
            </ReactKeycloakProvider>
        </ChakraProvider>
    </React.StrictMode>,
    document.getElementById('root'),
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
